import axios from "axios";
import { API_URL } from "const/constants";

const BASE = `${API_URL}/referrer-review`;
const unwrap = ({ data }) => data?.data ?? data;

export const getReferrerReview = () => axios.get(BASE).then(unwrap);

export const linkCustomReferrer = (body) => axios.post(`${BASE}/custom-links`, body).then(unwrap);
